import React from 'react';
import clsx from 'clsx';
import { useDisplayCurrency, useGtqRate } from '../../lib/currency';
import { useAuth } from '../../contexts/AuthContext';

/**
 * $/Q display-currency pill (properties list header). Mirrors the portal's
 * toggle: flips the site-wide preference every price display hook listens to.
 * Hidden while no Banguat rate is available (prices stay USD-only).
 */
export const CurrencyTogglePill: React.FC<{ theme?: string }> = ({ theme }) => {
    const isLight = theme !== 'dark';
    const rate = useGtqRate();
    const [currency, setCurrency] = useDisplayCurrency();
    // Mirror the choice into the account-level pref so it follows the user
    // across devices (AuthContext applies it at login). No-op when anon.
    const { realProfile, updateUIPreference } = useAuth();

    if (!rate) return null;

    return (
        <div
            role="group"
            aria-label="Moneda"
            title={`Tipo de cambio Banguat: Q${rate.toFixed(2)} por $1`}
            className={clsx(
                'flex items-center p-1 rounded-xl border shrink-0',
                isLight ? 'bg-slate-50 border-slate-200' : 'bg-black/20 border-white/5'
            )}
        >
            {(['USD', 'GTQ'] as const).map(c => (
                <button
                    key={c}
                    onClick={() => { setCurrency(c); if (realProfile) void updateUIPreference('display_currency', c); }}
                    aria-pressed={currency === c}
                    aria-label={c === 'USD' ? 'Mostrar precios en dólares' : 'Mostrar precios en quetzales'}
                    className={clsx(
                        'px-2.5 py-1.5 rounded-lg text-xs font-black transition-all',
                        currency === c
                            ? 'bg-white dark:bg-slate-800 text-indigo-600 dark:text-indigo-400 shadow-sm'
                            : 'text-slate-500 dark:text-slate-400 hover:text-slate-900 dark:hover:text-slate-200'
                    )}
                >
                    {c === 'USD' ? '$' : 'Q'}
                </button>
            ))}
        </div>
    );
};
